import Axios from "axios";
import {
    SET_INV_ISSUE_LIST,
    UNSET_INV_ISSUE_LIST,
  } from "@/store/mutation-types";
import {saveUpdateInvIssue, getInvIssueList , getInvIssueById as getInvIssueByIdApi} from "@/store/api";
// initial state
const state = {
  getInvIssueList: [],
  editingInvIssue: null,
};

const getters = {
  getInvIssueList(state) {
    return state.getInvIssueList;
  },
  getEditingIssue: (state) => { 
    return state.editingInvIssue;
  },
};

const mutations = {
  [SET_INV_ISSUE_LIST](state, data) {
    state.getInvIssueList = data;
  },
  [UNSET_INV_ISSUE_LIST](state) {
    state.getInvIssueList = [];
  },
  setEditingIssue(state, requisition) {
    state.editingInvIssue = requisition;
  },

};

const actions = {
  saveUpdateInvIssue({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateInvIssue, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getInvIssueList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getInvIssueList, data)
        .then(function (response) {
          commit('SET_INV_ISSUE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_INV_REQUISITION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getInvIssueById({ commit }, id) {
    const getInvIssueById = `${getInvIssueByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getInvIssueById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
